import {lazy} from 'react';

export const ProfileRoomsAsync = lazy(() =>
    import('./ProfileRooms')
);
